import CheckoutModalContainer from './CheckoutModalContainer';

export default CheckoutModalContainer;
